module.exports = __webpack_public_path__ + "static/media/info.782d1154.svg";